import { z } from 'zod';
import { createEnvironment } from '#common/utils/public-env.tsx';

const environmentSchema = z.intersection(
    z.object({ BASE_HOST: z.string() }),
    z.union([
        z.object({ NODE_ENV: z.literal('development') }),
        z.object({
            NODE_ENV: z.literal('production'),
            ENV: z.enum([ 'prod', 'stage' ]),
            COMMIT_SHA: z.string(),
            COMMIT_BRANCH: z.string(),
            COMMIT_DATE: z.string(),
            BUILD_DATE: z.string()
        }),
    ])
);

export const { environment, PublicEnv, getPublicEnv, getAllPublicEnv } = createEnvironment(environmentSchema);
